var base_url = 'https://api.openges.es';

export const API_CONFIG = {
    BASE_URL: base_url,
    API_URL: base_url + '/api/v1',
    CLIENT_ID: '2',
    CLIENT_SECRET: 'ifMtrOEqLK2LiYD7gu1NgKB3ZB3QrpeV6xZZh5rH',

}
